module.exports = "/images/lines-2.jpg";